import { RootState } from '@app/store/types';

export const isAuthenticated = (state: RootState): boolean => state.account.isAuthenticated;
export const isAccountRemoving = (state: RootState): boolean => state.account.isAccountRemoving;
